import { render, staticRenderFns } from "./CartLineSvg.vue?vue&type=template&id=b4584a5a&"
import script from "./CartLineSvg.vue?vue&type=script&lang=js&"
export * from "./CartLineSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports